'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');
const components_display_Badge_Badge = require('../../display/Badge/Badge.cjs.js');
const components_display_FloatingBox_FloatingBox = require('../../display/FloatingBox/FloatingBox.cjs.js');
const components_display_Tag_Tag = require('../../display/Tag/Tag.cjs.js');
const components_navigation_IconButton_IconButton = require('../IconButton/IconButton.cjs.js');
const components_forms_Menu_Menu = require('../../forms/Menu/Menu.cjs.js');
const components_forms_Menu_MenuItem = require('../../forms/Menu/MenuItem.cjs.js');
const hooks_useClickOutside = require('../../../hooks/useClickOutside.cjs.js');
const styleEncapsulation = require('@zapier/style-encapsulation');

const Styles = styleEncapsulation.labelStyles("TabsDropdown", {
  root: react.css`
    position: relative;
  `,
  summary: react.css`
    // Hides default icon on details element
    &::-webkit-details-marker {
      display: none;
    }

    &::before {
      display: none;
    }
  `,
  menu: react.css`
    padding: var(--zds-space-12);
    min-width: 250px;
  `,
  badgeAndTag: react.css`
    margin-left: var(--zds-space-8);
  `
});
const TabsDropdown = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const menuItems = props.items.map((item) => react.jsx(
    components_forms_Menu_MenuItem.MenuItem,
    { disabled: item.disabled, href: item.href, isSelected: item.href === props.selectedItemHref, key: item.href, onClick: (event) => {
      setIsOpen(false);
      props.onChooseItem(item, event);
    } },
    item.text,
    item.badgeText && react.jsx(components_display_Badge_Badge.Badge, { variant: item.badgeVariant, css: Styles.badgeAndTag }, item.badgeText),
    item.tagText && react.jsx(components_display_Tag_Tag.Tag, { variant: item.tagVariant, css: Styles.badgeAndTag }, item.tagText)
  ));
  const [setClickOutsideNode] = hooks_useClickOutside.useClickOutside({
    onClickOutside: () => {
      setIsOpen(false);
    }
  });
  const containerHandlers = {
    onKeyUp: (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    }
  };
  return react.jsx(
    "div",
    Object.assign({ ref: setClickOutsideNode }, containerHandlers, { "data-zds": true }),
    react.jsx(components_navigation_IconButton_IconButton.IconButton, { color: "icon-tertiary", icon: "navMoreHoriz", label: "More items…", "aria-expanded": isOpen, onClick: () => setIsOpen(!isOpen), size: "small", tooltipPosition: "west" }),
    isOpen && react.jsx(
      components_display_FloatingBox_FloatingBox.FloatingBox,
      { align: "right" },
      react.jsx(
        "div",
        { css: Styles.menu, "data-zds": true },
        react.jsx(components_forms_Menu_Menu.Menu, { "aria-label": "" }, menuItems)
      )
    )
  );
};

exports.TabsDropdown = TabsDropdown;
//# sourceMappingURL=TabsDropdown.cjs.js.map
